module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dashboard":"Dashboard","events":"Events","chats":"Chats","rooms":"Rooms","tournaments":"Tournaments","members":"Members","channels":"Channels","performance":"Performance"},"es":{"dashboard":"Dashboard","events":"Eventos","chats":"Chats","rooms":"Salas","tournaments":"Torneos","members":"Miembros","channels":"Canales","performance":"Rendimiento"}}')
  delete Component.options._Ctor
}
